import ApplicationController from './application_controller'

/**
 * Disclosure Controller - Collapsible section for nested navigation
 *
 * Manages expand/collapse state for documentation sidebar sections.
 * Supports initial state via data-disclosure-open-value attribute.
 *
 * @example
 *   <div data-controller="disclosure" data-disclosure-open-value="true">
 *     <button data-action="click->disclosure#toggle">Toggle</button>
 *     <div data-disclosure-target="content">Content</div>
 *   </div>
 */
export default class extends ApplicationController {
  static targets = ['content', 'icon']
  static values = { open: { type: Boolean, default: false } }

  connect () {
    this.render()
  }

  toggle () {
    this.openValue = !this.openValue
  }

  openValueChanged () {
    this.render()
  }

  render () {
    if (this.hasContentTarget) {
      this.contentTarget.hidden = !this.openValue
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('rotate-90', this.openValue)
    }
    this.element.dataset.disclosureOpen = this.openValue
  }
}
